import { HFCL_AGENT_URL } from '../../components/aiChatModule/hfclChatConfig';
import { countTurnCall, turnTimingSummary } from './turnTiming';
import { agentHeaders } from './agentApiClient';

/**
 * Report a safe command completion or failure event.
 * @param {object} event typed event
 * @return {Promise<object>} next agent response
 */
export async function sendAgentEvent(event) {
	// The turn rides on the event, having come back on the reply that asked
	// for this command - so the browser keeps no "current turn" that two
	// overlapping messages could fight over.
	if (event.turn_id) countTurnCall(event.turn_id);
	// The browser's own numbers for this turn, so the two halves of the
	// wait end up on one timeline instead of two nobody joins.
	const browserTiming = event.turn_id
		? turnTimingSummary(event.turn_id)
		: null;
	const response = await fetch(`${HFCL_AGENT_URL}api/agent/events`, {
		method: 'POST',
		credentials: 'include',
		headers: agentHeaders({'Content-Type': 'application/json'}),
		body: JSON.stringify(
			browserTiming ? {...event, browser_timing: browserTiming} : event,
		),
	});
	if (!response.ok) throw new Error(`Agent event failed: ${response.status}`);
	return response.json();
}
